import React from 'react';
import { Link } from 'react-router-dom';
import './QualityPolicy.css';

const QualityPolicy = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <h1 className="page-title">Quality Policy</h1>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), we are committed to providing our clients 
                with the highest quality certification services, including ISO, CE, Testing, Auditing, 
                and Evaluation. Our mission is to ensure the utmost integrity, reliability, and transparency 
                in all our processes, helping businesses achieve and maintain the standards required for 
                their respective industries.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">To achieve our quality objectives, we adhere to the following principles:</h2>
            <div className="principles-list">
              <div className="principle-item">
                <h3 className="principle-title">Client-Centric Approach</h3>
                <p className="principle-description">
                  We prioritize our clients' needs and expectations, ensuring that our certification 
                  services are tailored to meet their specific requirements. We maintain open 
                  communication and provide timely, accurate information throughout the certification process.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">Continuous Improvement</h3>
                <p className="principle-description">
                  We are dedicated to continuously enhancing our processes, methodologies, and services. 
                  We regularly review and update our practices to incorporate industry best practices 
                  and technological advancements, ensuring we deliver the most effective certification solutions.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">Compliance and Standards</h3>
                <p className="principle-description">
                  We strictly adhere to all applicable international standards, regulations, and 
                  industry requirements. Our certification processes are conducted in full compliance 
                  with relevant ISO standards, CE marking requirements, and other regulatory frameworks.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">Professional Excellence</h3>
                <p className="principle-description">
                  Our team consists of highly qualified and certified professionals who maintain 
                  the highest levels of expertise and competence. We invest in ongoing training and 
                  professional development to ensure our staff remains at the forefront of certification practices.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">Transparency and Integrity</h3>
                <p className="principle-description">
                  We conduct all our certification activities with complete transparency and integrity. 
                  We provide clear, honest communication about our processes, timelines, and outcomes, 
                  and we maintain the highest ethical standards in all our interactions.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">Customer Satisfaction</h3>
                <p className="principle-description">
                  Customer satisfaction is at the heart of everything we do. We measure and monitor 
                  client satisfaction regularly, and we are committed to addressing any concerns or 
                  feedback promptly and effectively to ensure the highest level of service delivery.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <div className="page-text-content">
              <p>
                By adhering to these principles, NQC (Nova Quality Certification Agency) ensures the 
                delivery of unparalleled certification services, fostering trust and confidence among 
                our clients and stakeholders.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default QualityPolicy;

